/*
 * @Author: Json Chen
 * @Date: 2022-05-27 09:15:42
 * @LastEditTime: 2022-06-06 16:06:10
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/TableActions/index.tsx
 */
import classNames from 'classnames';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

interface IProps {
  onEdit?: (e?: any) => void;
  onDelete?: (e?: any) => void;
  editText?: string;
  disabled?: boolean;
  disableDelete?: boolean;
  disableEdit?: boolean;
  isReverse?: boolean;
}

const TableActions = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onEdit,
    onDelete,
    editText,
    disabled,
    disableDelete,
    disableEdit,
    isReverse,
  } = props;
  return (
    <div
      className={classNames(
        css.tableLastContainer,
        isReverse && css.flexReverse,
      )}>
      {onDelete && (
        <div
          className={`${css.delete} ${
            disabled || disableDelete ? css.disabled : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
            if (!(disabled || disableDelete)) {
              onDelete();
            }
          }}>
          {getI18n('general.delete')}
        </div>
      )}
      {onEdit && (
        <div
          //className={css.edit}
          className={`${css.edit} ${
            disabled || disableEdit ? css.disabled : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
            if (!(disabled || disableEdit)) {
              onEdit();
            }
          }}>
          {editText || getI18n('general.edit')}
        </div>
      )}
    </div>
  );
};
export default TableActions;
